<template>
  <div class="quiz-result">
    <div class="intro mb-3">
      Twoje motto: „Każdy jest kowalem własnego losu”
    </div>

    <div class="cechy columns d-flex p-2">
      <div class="col-auto pt-3 images">
        <img :src="require('@/assets/images/segmentacja/thumb-designerzy-zycia.jpg')"
             alt="group thumbnail"
             class="img-responsive"/>
      </div>
      <div class="pl-4 pl-sm-0 description-col">
        <img :src="require('@/assets/images/segmentacja/icon-designerzy-zycia.png')"
             alt="group thumbnail"
             class="img-responsive mb-2 icon"/>
        <p>
          Jesteś osobą wewnątrzsterowną, nie chcesz, aby ktokolwiek wpływał na Twoje decyzje
          i&nbsp;planowanie przyszłości.<br/>
          Chcesz być niezależny finansowo i&nbsp;planować swoją ścieżkę rozwoju zawodowego,
          zgodnie z celami, jakie sobie wyznaczysz.
        </p>
        <p>
          Wiesz, że pieniądze są ważne, i&nbsp;nie masz problemu, aby o&nbsp;tym mówić głośno.
          Pieniądze są dla Ciebie środkiem do realizacji ważnych dla Ciebie rzeczy
          –&nbsp;kiedy ich nie ma, nie możesz się rozwijać i&nbsp;iść swoją drogą.
        </p>
        <p>
          Masz wrażenie, że każdy powinien zajmować się swoimi sprawami,
          a&nbsp;państwo powinno wspierać swoich obywateli w&nbsp;ich dążeniach.
        </p>
        <p>
          Czujesz, że cały świat stoi przed Tobą otworem, nie boisz się
          przeciwności losu i&nbsp;przeszkód.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DizajnerzyZycia',
};
</script>

<style scoped>
.intro {
  color: #FFFFFF;
  background: var(--color-dizajnerzy-zycia);
  font-size: 1.3em;
  font-weight: 700;
  padding: .6em .8em;
}
</style>
